import Colors from "../../theme/colors";

const Styles = {
  container: {
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.lightGray}`,
    borderRadius: "8px",
    height: "100",
    margin: 10,
  },
  tableContainer: {
    border: `1px solid #616161`,
  },
  linkStyle: {
    textDecoration: "none",
  },
  backButton: {
    fontSize: 14,
    border: "1px solid #ccc",
    borderRadius: "20px",
    color: "#616161",
    padding: "5px 10px",
  },
  formContainer: {
    margin: "4rem 2rem",
    minHeight: 400,
  },

  // forward intro remarks Styles
  ForwardIntroContainer: {
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.lightGray}`,
    borderRadius: "8px",
    height: "100",
    padding: 15,
  },

  buttonBox: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginBottom: 20,
  },
};

export default Styles;
